'use client';

import toast from '@shared/utils/helpers/toast';
import useUser from '@shared/utils/hooks/useUser';
import { usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';

import AppLayout from '../../layouts/AppLayout/AppLayout';
import { client } from '../../utils/trpc';
import Button from '../common/Button';
import Input from '../UI/Input';

const WaitList = () => {
  const { currentUser } = useUser();
  const router = useRouter();
  const pathname = usePathname();

  // Redirect if signed in
  useEffect(() => {
    if (currentUser.isAuthenticated) {
      router.push('/');
    }
  }, [currentUser.isAuthenticated]);

  const [email, setEmail] = useState('');

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const [error] = await client.users.waitList.mutate({ email });
    if (error) return;
    toast('Added to wait list successfully! Redirecting to home page...');
    setEmail('');
    setTimeout(() => {
      router.push('/');
    }, 2000);
  };

  return (
    <AppLayout>
      <div className="flex size-full flex-col items-center justify-center p-5">
        <h1 className="mb-4 text-3xl font-emphasis">
          Sign up for our Wait List!
        </h1>
        <p className="mb-10 max-w-md text-center text-textSecondary">
          Be first in line when new Factiii features open up — early access to
          upcoming releases on the community fact-checking platform, straight to
          your inbox. No spam, ever.
        </p>
        <Input
          className="mb-5"
          autofocus
          type="email"
          label="Email"
          value={email}
          onChange={setEmail}
        />
        <Button
          text="Get Early Access"
          type="submit"
          classNames="w-full mb-10"
          onClick={handleSubmit}
        />
        <QRCode
          value={`${process.env.NEXT_PUBLIC_SITE_URL}${pathname}`}
          size={200}
        />
      </div>
    </AppLayout>
  );
};

export default WaitList;
